import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { NotificationsService } from 'angular2-notifications';

import { ResourcesService } from '../../../../services/resources/resources.service';
import { EventsService } from '../../../../services/events/events.service';
import { SERVICES_URLS } from '../../../../services/resources/services.urls';
import { LocalStorageService } from 'ngx-webstorage';

import * as moment from 'moment-timezone';

@Component({
  selector: 'modal-survey',
  styleUrls: [('./modalSurvey.scss')],
  templateUrl: './modalSurvey.html'
})

export class ModalSurvey {
  @ViewChild('form') form;
  modalHeader: string;
  survey;
  folder: string = "";
  loading: Boolean;
  private fileList: FileList;
  private user: string = "";
  private base64textString: String = "";
  fileExtensionMessage = "";
  fileExtensionError = false;
  extension;

  constructor(
    private activeModal: NgbActiveModal,
    private _notificationService: NotificationsService,
    private _resourcesService: ResourcesService,
    private _element: ElementRef,
    private _localStorage: LocalStorageService,
    private _eventsService: EventsService
  ) {
    var user = _localStorage.retrieve('user_data');
    if (user != null)
      this.user = user;

    console.log(user);

    _localStorage.observe('user_data')
      .subscribe((token) => this.user = token);

    this.survey = {
      id_personal: '',
      id_usuario: ('000' + user.id).slice(-4),
      fecha: moment().format("YYYYMMDD"),
      hora: moment().format("HHmmss"),
      imagen_personal: "",
      cant_fotos: 1,
      cant_huellas: 0,
      cuadrilla: '',
      grupo: '',
      nombre: '',
      apellido: '',
      dni: '',
      legajo: '',
      activo: true
    };
  }

  ngOnInit() { }

  public closeModal() {
    this.activeModal.close();
  }

  public addPersonal() {
    this.getImportedPoints();
  }

  public uploadImage() {

  }

  public getImportedPoints() {
    this.loading = true;
    this.survey.id_personal = this.survey.dni;
    if (this.base64textString != null) {
      this._resourcesService.uploadFile(this.base64textString, this.survey.id_personal, this.survey.cant_fotos,"photo")
        .subscribe(
        (result) => this.setImportedData(result),
        (error) => this.getDataError(error)
        );
    }
    else {
      this.loading = false;
      this._notificationService.warn('Mensaje', 'No se seleccionó ningún archivo.');
    }
  }
  private showError(error) {
    this._notificationService.error('Mensaje', 'Error con los datos ingresados.');
  }

  private saveSurvey(survey) {
    this._eventsService.setObjectCrud(survey);
    this.activeModal.close();
  }

  public selectFile() {
    this.base64textString = null;
  }


  public fileChange(event) {
    var allowedExtensions = ["jpg", "jpeg", "png", "JPG", "JPEG", "PNG"];
    var files = event.target.files;
    var file = files[0];
    var photoName = file.name;
    var fileExtension = photoName.split('.').pop();
    this.extension = fileExtension;
    if (this.isInArray(allowedExtensions, fileExtension)) {
      this.fileExtensionError = false;
      this.fileExtensionMessage = ""
    } else {
      this.fileExtensionMessage = "solo Imagenes son permitidos jpg, jpeg, png!!"
      this.fileExtensionError = true;
    }

    if (files && file) {
      var reader = new FileReader();

      reader.onload = this._handleReaderLoaded.bind(this);

      reader.readAsBinaryString(file);
    }
  }

  isInArray(array, word) {
    return array.indexOf(word.toLowerCase()) > -1;
  }
  _handleReaderLoaded(readerEvt) {
    var binaryString = readerEvt.target.result;
    this.base64textString = btoa(binaryString);
    //console.log(this.base64textString);
  }

  private setImportedData(data) {
    //this.survey.imagen_personal = data.url_image;
    this.survey.id_personal = this.survey.dni;
    this._resourcesService.addPersonal(this.survey)
      .subscribe(
      result => this.saveSurvey(result),
      error => this.showError(error)
      );
  }
  //this.localStorage.store('imported_points', resultToAdd);
  //this.localStorage.store('resolved_points', resultToAddRes);
  //this.importedPoints = resultToAdd.concat(resultToAddRes);

  private getDataError(error) {
    this.loading = false;
    //this.localStorage.store('imported_points', []);
    //this.localStorage.store('resolved_points', []);
    this.form.nativeElement.reset();
    this._notificationService.error('Mensaje', 'Error al Subir la imagen.');
  }
}



// WEBPACK FOOTER //
// /app/src/app/theme/components/modals/components/modalSurvey/modalSurvey.component.ts